import { __generator } from "tslib";
import { takeLatest, select } from 'redux-saga/effects';
import * as actionTypes from '../constants/actionTypes';
import { getProjectID } from '../selectors';
export default function historyBack(history) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.HISTORY_BACK, function () {
                    var projectID, firstLocation;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(history.entries && history.index === 1)) return [3 /*break*/, 2];
                                return [4 /*yield*/, select(getProjectID)];
                            case 1:
                                projectID = _a.sent();
                                firstLocation = history.entries[0];
                                if (firstLocation.pathname.indexOf("/prototype/" + projectID) !== 0) {
                                    return [2 /*return*/];
                                }
                                _a.label = 2;
                            case 2:
                                history.goBack();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
